import styled from "styled-components";
import { PopoverContent } from "../../Overlays/Popover/Popover";

export const Content = styled(PopoverContent)`
  z-index: 20;
  display: flex;
  flex-direction: row;
  box-shadow: rgb(0 0 0 / 15%) 0px 0px 0px 1px, rgb(0 0 0 / 15%) 0px 8px 16px;
  border-radius: 4px;

  .w-color-swatch.w-color-github.w-color-chrome {
    width: 190px !important;
    border-top-left-radius: 4px !important;
    border-bottom-left-radius: 4px !important;

    > div:nth-child(1),
    > div:nth-child(2) {
      left: calc(50% + 5px) !important;
    }
  }

  .w-color-interactive.w-color-saturation {
    border-top-left-radius: 4px !important;
    border-bottom-left-radius: 4px !important;
  }
`;

export const Pick = styled.div`
  background-color: ${({ color }) => color};
  width: 28px;
  height: 28px;
  border-radius: 8px;
  border: 3px solid #ddd;
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.1), inset 0 0 0 1px rgba(0, 0, 0, 0.1);
  cursor: pointer;
`;

//Palette

export const PRESET_COLORS = [
  "#D0021B",
  "#F5A623",
  "#f8e61b",
  "#8B572A",
  "#7ED321",
  "#417505",
  "#BD10E0",
  "#9013FE",
  "#4A90E2",
  "#50E3C2",
  "#B8E986",
  "#000000",
  "#4A4A4A",
  "#FFFFFF"
];

export const styleSwatch = {
  borderTop: "1px solid rgb(238, 238, 238)",
  paddingLeft: 5,
  paddingTop: 5,
  width: "27px",
  background: "white",
  borderTopRightRadius: "4px",
  borderBottomRightRadius: "4px",
  border: "1px solid rgba(0, 0, 0, 0.2)",
  alignContent: "flex-start"
};
